import lodash from 'lodash';
import React from 'react';
import { DetectionFieldsFragment } from '../../../../../../generated/core-api/graphql-react-query';
import useDisplay from '../../../../MainWindow/Components/Pages/CardPage/Hooks/useDisplay';
import formatDetectionGroup from './utils/formatDetectionGroup';

export default function useDetectionVisibility(detections: DetectionFieldsFragment[], tab: { index: number, updatedAt: number }, latestDetection: { id: string, cardId: string, date: number, projectId: string } | null) {
  const [complianceOpenedAt, setComplianceOpenedAt] = React.useState<number | null>(null);
  const [cardsVisibility, setCardsVisibility] = React.useState<{ cardId: string, seenAt: number }[]>([]);
  const display = useDisplay();

  React.useEffect(() => {
    if (tab.index === 1) {
      setComplianceOpenedAt(tab.updatedAt);
    }
  }, [tab]);

  React.useEffect(() => {
    if (display.data?.getDisplay) {
      setCardsVisibility((prev) => {
        const others = prev.filter((item) => item.cardId !== display.data.getDisplay.cardId);
        return [{ cardId: display.data.getDisplay.cardId, seenAt: Date.now() }, ...others];
      });
    }
  }, [display.data?.getDisplay, latestDetection]);

  const detectionBadges = React.useMemo(() => {
    const map = new Map<string, number>();
    cardsVisibility.forEach((item) => {
      map.set(item.cardId, item.seenAt);
    });
    return map;
  }, [cardsVisibility]);

  const value = React.useMemo(
    () => Object.values(lodash.groupBy(detections, 'cardId'))
      .map((detectionGroup) => formatDetectionGroup(detectionGroup, detectionBadges, complianceOpenedAt))
      .sort((a, b) => (b.lastOccurrence - a.lastOccurrence)),
    [detections, detectionBadges, complianceOpenedAt],
  );

  return value;
}
